import { render, staticRenderFns } from "./CrossFreebie.vue?vue&type=template&id=50ca8cc2"
import script from "./CrossFreebie.vue?vue&type=script&lang=js"
export * from "./CrossFreebie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports